'use strict';

import register from './core';
import '../functions/jquery-global.js';
register('toggle-element', function (element) {
  var $toggler = $(element),
    moreText = $toggler.attr('data-more-text'),
    lessText = $toggler.attr('data-less-text'),
    $target = $toggler.prev(); // Default element to toggle is prev()

  $toggler.on('click', function (e) {
    e.stopPropagation();
    let expanded = $target.attr('aria-expanded');
    if (expanded === 'true') {
      $target.attr('aria-expanded', 'false');
      if (moreText) {
        $toggler.find('span').text(moreText);
      }
    } else {
      $target.attr('aria-expanded', 'true');
      if (lessText) {
        $toggler.find('span').text(lessText);
      }
    }
  });
});

register('interview-block-content-slide', function (element) {
  let $el = $(element),
    $button = $el.find('.toggle-button'),
    $content = $el.find('.interview-block-content'),
    $preview = $el.find('.preview'),
    $image = $el.find(".image-circle-container")
  $button.on('click', function (e) {
    e.stopPropagation();
    $content.slideToggle(1000);
    $image.fadeToggle(500);
    $preview.slideToggle(500);
    if ($preview.is(":visible")) {
      var offset = $el.offset();
      $('html, body').animate({
        scrollTop: offset.top - 100,
      }, 1000);
    }
  });
});

register('toggle-more-items', function (element) {
  let $el = $(element),
  $button = $el.find('.toggle-button'),
  $buttonText = $el.find('.toggle-button-text'),
  moreText = $el.attr('data-more-text'),
  lessText = $el.attr('data-less-text'),
  $content = $el.find('ul.toggle-items-list')
  $button.hide();
  $('ul.toggle-items-list').each(function () {
    if ($(this).find('li').length > 4) {
      $('li', this).eq(3).nextAll().hide().addClass('toggleable');
      $button.find($buttonText).text(moreText);
      $button.show();
    }
  });

  $button.on('click', function (e) {
    e.stopPropagation();
    var opened = $(this).hasClass('less');
    $(this).find($buttonText).text(opened ? moreText : lessText)
    $(this).toggleClass('less', !opened);
    $content.find("li.toggleable").fadeToggle('toggleable');
  });
}); 
